(function () {
    'use strict';
    var controllerId = 'cndPModuloAdd2A';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'modulo', 'corsoId', 'opInsert', fn_cndPModuloAdd2A]);

    function fn_cndPModuloAdd2A($scope, $uibModalInstance, modulo, corsoId, opInsert) {
        $scope.Title = '';

        if (modulo) {
            $scope.record = jQuery.extend({}, modulo); //Clona oggetto.
            $scope.Title = 'Modifica Modulo (ID: ' + $scope.record.Id + ')';
        }
        else {
            $scope.Title = 'Nuovo Modulo';
            $scope.record = {};
            $scope.record.Id = 0;
            $scope.record.CorsoId = corsoId;
            $scope.record.OpInsert = opInsert;
            $scope.record.Deleted = false;
            $scope.record.iVersion = 1;
            $scope.record.Ore = 0;
            $scope.record.TotOre = 0;  

            $scope.record.OreAula = 0;
            $scope.record.OreLaboratorio = 0;
            $scope.record.OreAltro = 0;

                      
        }      

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.record);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return item;
        }

        $scope.setTotOre = function () {
            var totale = 0;

            if (!$scope.record.Deleted && $scope.record.Ore > 0) {
                totale = parseInt($scope.record.Ore);
            }

            //if (!$scope.record.Deleted && $scope.record.OreAula > 0) {
            //    totale = parseInt($scope.record.OreAula);
            //}
            //if (!$scope.record.Deleted && $scope.record.OreLaboratorio > 0) {
            //    totale += parseInt($scope.record.OreLaboratorio);
            //}
            //if (!$scope.record.Deleted && $scope.record.OreAltro > 0) {
            //    totale += parseInt($scope.record.OreAltro);
            //}

            $scope.record.TotOre = totale;

            return $scope.record;
        };

    }
})();